var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regelement-container my-2"},[_c('a',{staticClass:"reglement-link px-4",attrs:{"href":_vm.getRegelement(),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('reglement')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }